module.exports = __webpack_public_path__ + "static/media/less-than.3c1bc4ad.svg";